const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de localizaciones',
  PAGE_DESCRIPTION:
    'Analiza y gestiona todos los aspectos de las localizaciones de tu almacen desde esta página.'
};

export default HELPER_TEXTS;
